import React from 'react';
import PropTypes from 'prop-types';

import Loading from '../../loading/loading'
import List from '../list/list'
import Empty from '../empty'

import SidePanel from '../panels/sidePanel/sidePanel'
import SidePanelContainer from '../panels/sidePanel/sidePanel-transition'


import { FormattedMessage } from 'react-intl';

import './browseFiles'

class BrowseFiles extends React.Component {

    static SIDE_PANEL_ID = "sidePanel-browse";

    constructor(props){
        super(props);
        this.state = {
            view: Object.keys(this.props.views)[0]
        }
    }

    render() {
        let { branch, loading=false, views, requestFile } = this.props;
        let viewSelected = this.state.view;

        let { files={} } = branch;
        let { collection=[] } = files;

        let elementsList = collection.map( file =>
            <Sidepanel openerType={views[viewSelected]} openerAttrs={{file, onClick: (e)=> requestFile(file)}} containerId={BrowseFiles.SIDE_PANEL_ID}/>
        );

        return (<div className='browseFiles'>
            <Loading printable={loading && collection.length === 0}/>
            {!loading && <div>
                <div className="browseFiles-views">
                    {collection.length>0 && Object.keys(this.props.views)
                        .filter(v => v !== viewSelected)
                        .map( view => <button onClick={ event => this.setState({view}) } key={view}>
                            <FormattedMessage id={'app.components.browse.' + view} />
                        </button>)}
                </div>

                <List className="browseFiles-list" printable={viewSelected} collection={elementsList} />
            </div>}
            <SidePanelContainer id={BrowseFiles.SIDE_PANEL_ID} />
        </div>);
    }
}

BrowseFiles.propTypes = {
    requestFile: PropTypes.func.isRequired,
    branch: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    views: PropTypes.object.isRequired,
}

export default BrowseFiles
